module.exports = __webpack_public_path__ + "img/step5-08.990e064c.jpg";